// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__ILPRY","content":"LoadingAlert_content__1BO3X"};